export default "__VITE_ASSET__fd1a559e__"